<script>
import axios from 'axios';
import AS from '@/services/AuthenticationService';

export default {
  fetchPaymentSlips({ status = '', page }) {
    const params = { status, page };
    return axios.get('requerimentos/boletos-de-complemento', { params, ...AS.getDefaultHeaders() });
  },
  adminFetchPaymentSlips({ status = '', page }) {
    const params = { status, page };
    return axios.get('admin/requerimentos/boletos-de-complemento', { params, ...AS.getDefaultHeaders() });
  },
  createAdditionalPaymentSlip({ applicationId, value }) {
    return axios.post(`admin/requerimentos/${applicationId}/boleto-complementar`, { value }, AS.getDefaultHeaders());
  }
};

</script>